/**
 * L'affichage d'un score du concours : une décimale, dans la langue du lecteur.
 *
 * Le serveur calcule en valeurs exactes et décide seul des égalités ; on
 * n'arrondit ici que pour l'œil. Deux candidats affichés « 106,1 » peuvent
 * donc être à égalité ou non — c'est le rang renvoyé par le serveur qui le
 * dit, jamais une comparaison de chaînes.
 */
export function formatScore(value: number, language: string): string {
  return new Intl.NumberFormat(language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value)
}

/** Une part (déjà en pourcentage), à une décimale. */
export function formatShare(value: number, language: string): string {
  return new Intl.NumberFormat(language, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100)
}
